import { CONFLUENCY_COLORS } from '../constants'

// Hardcoded bin edges (cells/mL) where 1B (1e9) represents the 80th percentile
// 5 equal bins: each bin is 20% of the range (like ConfluenceHistogram)
// xMax = 1.25e9 (so 1B is at 80%), so bins are: 0-250M, 250M-500M, 500M-750M, 750M-1B, 1B-1.25B
export const CELL_CONCENTRATION_BIN_EDGES = [2.5e8, 5e8, 7.5e8, 1e9] as const

const EMPTY_CULTURE_COLOR = '#EAEAEA'

/**
 * Returns one of 5 CONFLUENCY_COLORS based on cell concentration (cells/mL).
 *
 * Uses 5 equal bins (like ConfluenceHistogram) where 1B (1e9) represents the 80th percentile.
 * Each bin is 20% of the range (0 to 1.25e9).
 *
 * Bin ranges (5 total):
 *   0: <2.5e8 (0-250M)     → color[0] (light blue)
 *   1: [2.5e8–<5e8)        → color[1]
 *   2: [5e8–<7.5e8)        → color[2]
 *   3: [7.5e8–<1e9)        → color[3]
 *   4: ≥1e9 (1B and above) → color[4] (orange)
 */
export function getCellConcentrationColor(cellsPerMl?: number | null) {
  if (cellsPerMl == null || Number.isNaN(cellsPerMl)) {
    return EMPTY_CULTURE_COLOR
  }

  // Determine discrete bin index 0..4 (5 bins total)
  let idx = 0
  if (cellsPerMl < CELL_CONCENTRATION_BIN_EDGES[0]) {
    idx = 0
  } else if (
    cellsPerMl >= CELL_CONCENTRATION_BIN_EDGES[CELL_CONCENTRATION_BIN_EDGES.length - 1]
  ) {
    idx = CELL_CONCENTRATION_BIN_EDGES.length // 4
  } else {
    for (let i = 0; i < CELL_CONCENTRATION_BIN_EDGES.length - 1; i++) {
      const lo = CELL_CONCENTRATION_BIN_EDGES[i]
      const hi = CELL_CONCENTRATION_BIN_EDGES[i + 1]
      if (cellsPerMl >= lo && cellsPerMl < hi) {
        idx = i + 1
        break
      }
    }
  }

  // Direct 1:1 mapping of 5 bins to 5 colors (like ConfluenceHistogram)
  return CONFLUENCY_COLORS[idx]
}
